import { render, staticRenderFns } from "./EdicionPermiso.vue?vue&type=template&id=c6718832"
import script from "./EdicionPermiso.vue?vue&type=script&lang=js"
export * from "./EdicionPermiso.vue?vue&type=script&lang=js"
import style0 from "./EdicionPermiso.vue?vue&type=style&index=0&id=c6718832&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports